import { Stack, StackTypeMap, Typography } from "@mui/material";
import React from "react";
import { Project } from "../types";
import { DefaultComponentProps } from "@mui/material/OverridableComponent";

interface IChipsProps extends Partial<DefaultComponentProps<StackTypeMap<{}, "div">>> {
  tags: Project["tags"];
}

const Chips: React.FC<IChipsProps> = ({ tags, ...props }) => (
  <Stack
    width="100%"
    flexDirection="row"
    color="text.primary"
    justifyContent="space-between"
    {...props}
  >
    <Stack gap={1} direction="row" flexWrap="wrap">
      {tags.map((tag) => (
        <Typography
          key={`tag_${tag}`}
          variant="caption"
          sx={{
            backgroundColor: "grey.100",
            whiteSpace: "nowrap",
            py: "6px",
            px: { xs: 0.75, sm: 1, md: 1.25 },
          }}
        >
          {tag}
        </Typography>
      ))}
    </Stack>
  </Stack>
);

export default Chips;
